<template>
    <Card>
        <div>
            <div class="sousuo" style="width: 100%">
                <div style="width: 450px" class="yl-flex flex_between">
                    <Input placeholder="搜索客户姓名/电话" v-model="name" style="width: 300px">
                        <i-button slot="append" icon="ios-search" @click="search"></i-button>
                    </Input>
                    <Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
                    <Button class='ivu-btn-circle' @click="initSearch">重置</Button>
                </div>

            </div>
            <div class="multiple">
                <div class="child-div">时间区间</div>
                <RadioGroup v-model="timePeriod">
                    <Radio label="0"><span>不限</span></Radio>
                    <Radio label="1"><span>今日</span></Radio>
                    <Radio label="2"><span>昨日</span></Radio>
                    <Radio label="3"><span>本周</span></Radio>
                    <Radio label="4"><span>上周</span></Radio>
                    <Radio label="5"><span>本月</span></Radio>
                    <Radio label="6"><span>上月</span></Radio>
                    <Radio label="7"><span>自定义</span></Radio>
                    <DatePicker v-show="timePeriod == '7' " :value="timePeriodDate" @on-change="timePeriodDateChange"
                                type="daterange"
                                placeholder="选择日期" style="width: 200px"></DatePicker>
                </RadioGroup>
            </div>
            <div class="multiple">
                <div class="child-div">所属部门</div>
                <Select v-model="department" style="width:200px">
                    <Option v-for="item in departmentList" :value="item.value" :key="item.value">{{ item.label }}
                    </Option>
                </Select>
            </div>
            <div style="width: 100% ;margin-top: 20px;">
                <Table :columns="columns" :data="datas" size="small" ref="table">
                    <template slot-scope="{ row }" slot="name">
                        <div style="display: flex; align-items: center;">
							<div v-if="row.type == 1 "
								 style="text-align: center;width: 20px; height: 20px; line-height: 20px; background-color: #14BD98; color: #FFFFFF; border-radius: 50%;">
								个
							</div>
							<div v-if="row.type == 2 "
								 style="text-align: center;width: 20px; height: 20px; line-height: 20px; background-color: #0C92F4; color: #FFFFFF; border-radius: 50%;">
								企
							</div>
							<div style="display: flex;flex-direction: column; align-items: center;">
								<span>{{row.name}}</span>
								<span>{{row.phone}}</span>
							</div>
                        </div>
                    </template>

                    <template slot-scope="{ row }" slot="operation">
                        <div style="color: #0092FF; cursor: pointer;" :data-id="row.id" @click="sureSincerity">确认收款</div>
                    </template>
                </Table>
            </div>
            <div class="pager">
                <Page :total="count" :page-size="20" :current="page" @on-change="changePage" size="small"
                      show-elevator/>
            </div>


        </div>
    </Card>
</template>
<script>
    import {mapGetters} from "vuex";
	import {
		getSincerityList,sureSincerity
	} from '@/api/finance'
	import {getDepartmentList} from "../../api/user";
	export default {
        name: "GatheringAffirm",
        components: {},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
        data() {
            return {
                count: 0,
                page: 1,
                name: '',
                timePeriod: '0',
                timePeriodDate: [],
                department: 0,
                departmentList: [],
                datas: [],
                columns: [
                    {
                        "title": "客户信息",
                        "slot": "name",
                        width: '130'
                    },
                    {
                        "title": "媒体代码",
                        "key": "media_name"
                    },
                    {
                        "title": "所属部门",
                        "key": "department",
                    },
                    {
                        "title": "所属员工",
                        "key": "follow_name",
                    },
                    {
                        "title": "缴纳日期",
                        "key": "created_at",
                    },
                    {
                        "title": "金额",
                        "key": "sincerity_money",
                    },
					{
						"title": "缴纳方式",
						"key": "sincerity_type_name",
					},
                    {
                        "title": "诚意金状态",
                        "key": "status_name",
                    },
                    {
                        "title": "操作",
                        "slot": "operation",
                    }
                ],
            }
        },
        mounted: function () {
        	this.loadData();
			this.getList();
        },
        methods: {
            timePeriodDateChange(e) {
                this.timePeriodDate = e
            },
            initSearch() {
            	this.name = '';
                this.department = 0;
            	this.timePeriod = 0;
            	this.timePeriodDate = [];
            },
			async loadData() {
				let that = this;
				that.initSearch();
				var data = {token: this.token};
				var res = await getDepartmentList(that, data);
				if (res.code == 1) {
					that.departmentList = res.data.list;
				}
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.menu = 'gathering_affirm';
				data.token = this.token;
				data.page = this.page;
				let res = await getSincerityList(that, data);
				that.datas = res.data.list;
				that.count = res.count;
			},
			search() {
				this.page = 1;
				this.getList();
			},
			// 确认收款
			sureSincerity(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				this.$Modal.confirm({
					title: '确认收款吗？',
					onOk: async () => {
						let res = await sureSincerity(that, {token: that.token, id: id});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					}
				})
			}
        },


    }
</script>
<style scoped lang="less">

    .yellow_btn {
        color: #F8BD66;
    }

    .multiple {
        display: flex;
        justify-content: left;
        margin-top: 10px;
        align-items: center;

        .child-div {
            width: 70px;
            height: 20px;
            margin-right: 30px;
            text-align-last: justify;
        }
    }


    .sousuo {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .yl-flex {
        display: flex;
    }

    .flex_between {
        align-items: flex-start;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }
</style>
